import { render, staticRenderFns } from "./SlidableCard.vue?vue&type=template&id=67133580"
import script from "./SlidableCard.vue?vue&type=script&lang=js"
export * from "./SlidableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports